import { Component, Input, OnInit } from '@angular/core'
import { Dictionary } from '../../../../types/dictionary.type';
import { TableActionService } from '../../../custom-table/services/table-action.service';

export type OrderExecutersItems = 'driver'
  | 'dispatcher'
  | 'carrier'
  ;
@Component({
  selector: 'app-order-executers-common-view',
  templateUrl: './order-executers-common-view.component.html',
  styleUrls: ['./order-executers-common-view.component.scss'],
})
export class OrderExecutersCommonViewComponent implements OnInit {

  @Input() driver: OrderExecuterModel;
  @Input() dispatcher: OrderExecuterModel;
  @Input() carrier: OrderExecuterModel;

  @Input() config: Dictionary<OrderExecutersItems, OrderExecutersModel> = {};
  items: OrderExecutersModel[] = [];

  constructor(private readonly tableActionService: TableActionService) {
  }

  getConfig = (config: Dictionary<OrderExecutersItems, OrderExecutersModel>) => ({
    driver: {
      config: {
        role: 'Driver',
        isDisplayed: true,
        ...(config.driver && config.driver.config || {}),
      },
    },
    dispatcher: {
      config: {
        role: 'Dispatcher',
        isDisplayed: true,
        ...(config.dispatcher && config.dispatcher.config || {}),
      },
    },
    carrier: {
      config: {
        role: 'Carrier',
        isDisplayed: true,
        ...(config.carrier && config.carrier.config || {}),
      },
    },
  })

  ngOnInit() {
    this.config = this.getConfig(this.config);

    this.setValue('driver', this.driver);
    this.setValue('dispatcher', this.dispatcher);
    this.setValue('carrier', this.carrier);

    this.items = Object.values(this.config).filter(x => x.config.isDisplayed);
  }

  private setValue(item: OrderExecutersItems, value: OrderExecuterModel) {
    const model = this.config[item];
    model.value = value;
  }

  click(model: OrderExecutersModel) {
    model.config.click && model.config.click(this.tableActionService);
  }
}

export class OrderExecutersModel {
  value?: OrderExecuterModel;
  config: OrderExecutersConfiguration;
}

class OrderExecutersConfiguration {
  isDisplayed: boolean;
  click?: (StableActionService: TableActionService) => void; 
  role: string;
}

class OrderExecuterModel {
  firstName: string;
  lastName: string;
  avatarUrl: string;
}

